import {booleanAttribute, Component, input} from '@angular/core';

/**
 * Form field with the label above the control (design: label 14px/500, "· optioneel" in grey).
 * Put the hint in a `mat-hint` inside the mat-form-field; for other controls use `<span hint>`.
 */
@Component({
    selector: 'app-field',
    templateUrl: './field.component.html',
    styleUrl: './field.component.scss',
    host: {
        '[class.full]': 'full()'
    }
})
export class FieldComponent {
    readonly label = input<string>();
    readonly for = input<string>();
    readonly optional = input(false, {transform: booleanAttribute});
    /** Spans all columns of the section grid. */
    readonly full = input(false, {transform: booleanAttribute});
}
